import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { alpha, SxProps, Theme, useTheme } from "@mui/material/styles";

export interface GuidanceBannerProps {
  title: string;
  message: React.ReactNode;
  sx?: SxProps<Theme>;
  icon?: React.ReactNode;
  dataTestId?: string;
}

export default function GuidanceBanner({
  title,
  message,
  sx,
  icon,
  dataTestId,
}: Readonly<GuidanceBannerProps>) {
  const theme = useTheme();
  const resolvedIcon = icon ?? <InfoOutlinedIcon fontSize="small" />;

  return (
    <Paper
      variant="outlined"
      data-testid={dataTestId}
      sx={{
        p: 1.5,
        borderRadius: 1,
        backgroundColor: alpha(theme.palette.info.main, 0.08),
        borderColor: alpha(theme.palette.info.main, 0.2),
        borderLeft: `4px solid ${theme.palette.info.main}`,
        boxShadow: "none",
        ...sx,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
        <Box sx={{ color: theme.palette.info.main, mt: 0.25, flexShrink: 0 }}>
          {resolvedIcon}
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: "0.875rem",
              color: theme.palette.info.dark,
              fontWeight: 500,
              mb: 0.5,
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: "0.8rem",
              color: theme.palette.info.dark,
            }}
          >
            {message}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
}